import { GET_CLEANER, REQUEST_CLEANER } from '../actions/Types';

const getCleanerReducer = (state={loading: false, data: []}, action) => {
    if (action.type === GET_CLEANER){
        return {loading: false ,data: action.payload}
    }
    else if (action.type === REQUEST_CLEANER){
        return {loading: true, data: []}
    }
    return state
}

export default getCleanerReducer